import { render, staticRenderFns } from "./RelatedFiles.vue?vue&type=template&id=854be0aa&"
import script from "./RelatedFiles.vue?vue&type=script&lang=js&"
export * from "./RelatedFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports